import React from 'react';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';

const Highcharts = window.Highcharts;

function ConversionBreakdownGraph({ chartData, isAutomotiveIndustry }) {
  const chartOptions = {
    exporting: { enabled: false },
    credits: { enabled: false },
    chart: {
      type: 'column',
      marginBottom: 70,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    },
    legend: {
      floating: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      stackLabels: {
        enabled: true,
        formatter: function () {
          return this.total !== 0 ? this.total : '';
        },
      },
    },
    tooltip: {
      shared: false,
      headerFormat: '<b>{point.x}</b><br/>',
      pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          color: 'white',
          formatter: function () {
            return this.y !== 0 ? this.y : '';
          },
        },
      },
    },
    series: [
      {
        name: 'Calls',
        data: chartData.map((el) => el.calls),
        color: '#106DB6',
      },
      {
        name: 'Chats',
        data: chartData.map((el) => el.chats),
        color: '#9B7BB7',
      },
      {
        name: 'Texts',
        data: chartData.map((el) => el.texts),
        color: '#607D8B',
      },
      {
        name: 'WebForms',
        data: chartData.map((el) => el.leads),
        color: '#009999',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'top',
              layout: 'horizontal',
              itemMarginTop: 0,
              itemMarginBottom: 0,
              padding: 0,
            },
          },
        },
      ],
    },
  };

  return (
    <div className='row row_spacer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>
            {isAutomotiveIndustry
              ? 'Conversion by Day of Week'
              : 'Total Connections by Day of Week'}
          </div>
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
      </div>
    </div>
  );
}

ConversionBreakdownGraph.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      calls: PropTypes.number,
      chats: PropTypes.number,
      texts: PropTypes.number,
      leads: PropTypes.number,
    })
  ).isRequired,
  isAutomotiveIndustry: PropTypes.bool.isRequired,
};

export default ConversionBreakdownGraph;
